import React, { useState, useEffect } from "react";
import { Slider, ConfigProvider } from "antd";

/**
 * مكون Slider مخصص باستخدام Ant Design (v5) كبديل عن ReactSlider
 *
 * @param {Object} props - خصائص المكون
 * @param {number} [props.minProp=5] - القيمة الدنيا للسلايدر
 * @param {number} [props.maxProp=100] - القيمة القصوى للسلايدر
 * @param {number[]} [props.defaultValueProp=[20,50]] - القيمة الافتراضية للسلايدر (نطاق)
 * @param {number} [props.minDistanceProp=10] - المسافة الدنيا بين المؤشرين
 * @param {Function} [props.returnProp] - دالة callback للقيم المختارة
 * @param {string} [props.className=''] - كلاس إضافي للسلايدر
 */
function AntdPriceSlider({
  minProp = 5,
  maxProp = 100,
  defaultValueProp = [20, 50],
  minDistanceProp = 10,
  returnProp,
  className = "",
  customStyles = {},
  isRTL=true // خاصية للأنماط المخصصة
}) {
  const [values, setValues] = useState(defaultValueProp);
  const [tooltipVisible, setTooltipVisible] = useState([false, false]);

  // الأنماط الافتراضية
  const defaultStyles = {
    rail: {
      height: "4px",
      backgroundColor: "rgba(34, 202, 78, 0.25)",
      //   borderRadius: "4px",
      border: "1px solid #d9d9d9",
    },
    track: {
      height: "4px",
      backgroundColor: "#22ca4e",
      //   borderRadius: "4px",
    },
    handle: {
      //   height: "22px",
      //   width: "22px",
      borderColor: "#22ca4e",
      backgroundColor: "#ffffff",
    },
  };

  // دمج الأنماط الافتراضية مع المخصصة
  const mergedStyles = {
    rail: { ...defaultStyles.rail, ...customStyles.rail },
    track: { ...defaultStyles.track, ...customStyles.track },
    handle: { ...defaultStyles.handle, ...customStyles.handle },
  };

  /**
   * معالجة تغيير قيمة السلايدر
   */
  const handleChange = (newValues) => {
    if (newValues[1] - newValues[0] >= minDistanceProp) {
      setValues(newValues);

      if (returnProp) {
        returnProp({ start: newValues[0], end: newValues[1] });
      }
    }
  };

  /**
   * عند بدء السحب - إظهار tooltip
   */
  const handleStartDrag = (index) => {
    const newTooltipState = [false, false];
    newTooltipState[index] = true;
    setTooltipVisible(newTooltipState);
  };

  /**
   * عند انتهاء السحب - إخفاء tooltip
   */
  const handleAfterChange = () => {
    setTooltipVisible([false, false]);
  };

  // تحديث الحالة عند تغيير الخاصيات
  useEffect(() => {
    setValues(defaultValueProp);
  }, [defaultValueProp]);
  return (
    <div className={`antd-price-slider ${className}`}>
      {/* عرض القيم الحالية (اختياري) */}

      {/* 
                مكون Ant Design Slider
                range={true} يجعل السلايدر يعرض مؤشرين للنطاق
            */}

      <ConfigProvider direction={isRTL ? "rtl" : "ltr"}>
        <Slider
          // الخصائص الأساسية
          range // لتحديد نطاق[citation:1][citation:3]
          min={minProp} // القيمة الدنيا[citation:1]
          max={maxProp} // القيمة القصوى[citation:1]
          value={values} // القيمة الحالية[citation:1]
          defaultValue={defaultValueProp} // القيمة الافتراضية[citation:1]
          // دوال الأحداث
          onChange={handleChange} // عند تغيير القيمة[citation:3]
          onAfterChange={handleAfterChange} // بعد انتهاء التغيير[citation:3]
          // خصائص إضافية
          step={1} // خطوة التغيير[citation:1]
          // تخصيص tooltip - يظهر فقط عند السحب
          tooltip={{
            open: tooltipVisible.some((v) => v), // يظهر فقط إذا كان أحد المؤشرين نشط
            placement: "top",
            formatter: (value) => `${value} ريال`,
            getPopupContainer: (triggerNode) => triggerNode.parentNode,
          }}
          // تخصيص المؤشرات (handles) لإضافة events
          handleRender={(origin, info) => {
            return React.cloneElement(origin, {
              onMouseEnter: () => handleStartDrag(info.index),
              onMouseDown: () => handleStartDrag(info.index),
            });
          }}
          // خصائص التصميم (اختيارية)
          // يمكن استخدامها لمطابقة تصميم تطبيقك
          styles={mergedStyles} // استخدام الأنماط المدمجة
          // إمكانية سحب المسار بين المؤشرين
          // متوفر في Ant Design v5
          // range={{ draggableTrack: true }} // (تعليق) تفعيل إذا كنت تحتاج هذه الميزة

          // خصائص إضافية قد تحتاجها
          disabled={false} // تعطيل/تفعيل السلايدر[citation:1]
          keyboard={true} // التحكم بالسلايدر باستخدام لوحة المفاتيح[citation:1]
        />
      </ConfigProvider>
      <div
        style={{
          marginTop: "1rem",
          textAlign: "center",
          fontSize: "14px",
          color: "#666",
        }}>
        <span className="text-2xl text-gray  sm:text-3xl md:text-3xl lg:text-2xl font-bold">النطاق المحدد: </span>
        <strong className="text-2xl text-gray  sm:text-3xl md:text-3xl lg:text-2xl font-bold">
          {values[0]} ريال - {values[1]} ريال
        </strong>
      </div>
    </div>
  );
}

export default AntdPriceSlider;
